import React from "react";
import PredictionPage from "../../components/PredictionPage";

function US30() {
  return (
    <PredictionPage
      title="US30"
      content="This is the US30 AI Trading Predictions page."
      canonical="/indices/us30-ai-trading-predictions"
      categoryKey="nav.indices"
      categoryPath="/indices"
      symbol="US30"
    />
  );
}

export default US30;
